import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0763a8f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "WarehouseId" }
const _hoisted_2 = {
  key: 0,
  class: "bg-white px-6 py-4 border flex flex-col justify-center items-center"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400" }, "Загрузка...", -1))
const _hoisted_4 = { class: "WarehouseId__header" }
const _hoisted_5 = { class: "flex items-center gap-3" }
const _hoisted_6 = { class: "WarehouseId__container" }
const _hoisted_7 = { class: "mb-4 flex items-center justify-between" }
const _hoisted_8 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "ID", -1))
const _hoisted_10 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Город", -1))
const _hoisted_12 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Название склада", -1))
const _hoisted_14 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Ответственное лицо", -1))
const _hoisted_16 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Полный адрес", -1))
const _hoisted_18 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Телефон", -1))
const _hoisted_20 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "email", -1))
const _hoisted_22 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Широта", -1))
const _hoisted_24 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Долгота", -1))
const _hoisted_26 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Дата создания", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold mt-3" }, "График работы", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_loader, { class: "mt-1 primary" })
        ]))
      : (_ctx.state.warehouse)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_page_title, {
                  title: `Склад (${_ctx.state.warehouse.titleRu})`
                }, null, 8, ["title"]),
                _createVNode(_component_cheap, {
                  class: _normalizeClass(["small", { 'green': _ctx.state.warehouse.expressEnabled }])
                }, {
                  default: _withCtx(() => [
                    (_ctx.state.warehouse.expressEnabled)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode("Экспресс доставка включена")
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode("Экспресс доставка выключена")
                        ], 64))
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              _createVNode(_component_the_button, {
                class: "primary small mr-2",
                onClick: _ctx.goEdit
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Редактировать ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_page_title, { title: "Общая информация" })
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.warehouse.id), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.warehouse.cityName), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.warehouse.titleRu), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.warehouse.fullNameRu), 1)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.warehouse.fullAddressRu), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.warehouse.phone), 1)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.warehouse.email), 1)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.warehouse.latitude), 1)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.warehouse.longitude), 1)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.warehouse.createdAt), 1)
              ]),
              _hoisted_28,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.warehouse.schedules, (schedule) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `warehouse-schedule-${schedule.id}`,
                  class: "WarehouseId__schedule-row"
                }, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.WEEK_DAYS[schedule.weekday]), 1),
                  _createElementVNode("div", null, _toDisplayString(schedule.workTimeFrom), 1),
                  _createElementVNode("div", null, _toDisplayString(schedule.workTimeUntil), 1)
                ]))
              }), 128))
            ])
          ], 64))
        : _createCommentVNode("", true)
  ]))
}